import Backbone from 'backbone'
import $ from './jquery.js'

Backbone.$ = $;

export default Backbone
